module.exports = __webpack_public_path__ + "static/media/stageclear.1274f7c9.wav";